import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CardSkeleton } from './CardSkeleton';
export const ListSkeleton = React.forwardRef(({ count = 3, spacing = 16, animation = 'shimmer', itemComponent: ItemComponent = CardSkeleton, style, className, ...rest }, ref) => {
    const gapValue = typeof spacing === 'number' ? `${spacing}px` : spacing;
    const gapStyle = { gap: gapValue };
    return (_jsx("div", { ref: ref, className: `flex flex-col ${className || ''}`, style: { ...gapStyle, ...style }, role: "status", "aria-label": "Loading list", ...rest, children: Array.from({ length: Math.max(count, 1) }).map((_, index) => (_jsx(ItemComponent, { animation: animation }, index))) }));
});
